import createAxiosClient, { config } from "../utils/api-utils";
import authService from "../services/auth.service";

class AuthApi {
  constructor() {
    this.client = createAxiosClient();
  }

  /**
   * Login - Uses authService for Cognito authentication
   */
  async login(email, password) {
    return await authService.login(email, password);
  }

  /**
   * Login with phone number + password
   */
  async loginWithPhone(phone, password) {
    return await authService.loginWithPhone(phone, password);
  }

  /**
   * Signup - Uses authService for Cognito registration
   */
  async signUp(data) {
    return await authService.signup(data);
  }

  /**
   * Confirm email verification after signup
   */
  async confirmSignup(email, code) {
    return await authService.confirmSignup(email, code);
  }

  /**
   * Resend verification code
   */
  async resendCode(email) {
    return await authService.resendCode(email);
  }

  /**
   * Get current authenticated user profile
   */
  async userMe() {
    return await this.client.get("/users/me");
  }

  /**
   * Initiate forgot password - backend will call Cognito ForgotPassword
   */
  async forgotPassword(email) {
    return await this.client.post('/auth/forgot-password', { email });
  }

  /**
   * Confirm forgot password with code + new password
   */
  async confirmForgotPassword(email, code, newPassword) {
    return await this.client.post('/auth/confirm-forgot-password', { email, code, newPassword });
  }

  /**
   * Change password for the logged-in user
   */
  async changePassword(currentPassword, newPassword) {
    return await this.client.post('/auth/change-password', { currentPassword, newPassword });
  }

  /**
   * Create user profile after signup
   * @deprecated - Profile is now created during signup
   */
  async signUpProfile(data) {
    return await this.client.post("/profile", data);
  }

  /**
   * Update user profile
   */
  async updateProfile(data) {
    // The backend extracts userId from the JWT claims; no id required here
    return await this.client.patch(`/profiles`, data, config());
  }

  /**
   * Get user profile data
   */
  async getUserProfileData() {
    return await this.client.get("/users/me");
  }

  /**
   * Get user profile for update form
   */
  async getUserProfileUpdateData() {
    return await this.client.get("/users/me");
  }

  /**
   * Logout
   */
  logout() {
    authService.logout();
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated() {
    return authService.isAuthenticated();
  }

  /**
   * Refresh tokens
   */
  async refreshTokens() {
    return await authService.refreshTokens();
  }
}

export default AuthApi = new AuthApi();
